import classNames from 'classnames';
import React, { ReactElement } from 'react';

import { IParentProps } from '../../shared/types/IParentProps';

import { TAB_NAVIGATION_ORIENTATIONS } from './TAB_NAVIGATION_ORIENTATIONS';
import { TAB_NAVIGATION_SIZES } from './TAB_NAVIGATION_SIZES';

type ITabLayoutProps = IParentProps & {
    orientation: TAB_NAVIGATION_ORIENTATIONS;
    size: TAB_NAVIGATION_SIZES;
};

export function OzTabLayout (props: ITabLayoutProps): ReactElement {
    const { children, orientation, size }: ITabLayoutProps = props;

    if (orientation === TAB_NAVIGATION_ORIENTATIONS.VERTICAL) {
        return <div className="mb-2">{children}</div>;
    }

    const layoutClassNames: string = classNames({
        'mr-3': size === TAB_NAVIGATION_SIZES.SMALL || size === TAB_NAVIGATION_SIZES.MEDIUM,
        'mr-5': size === TAB_NAVIGATION_SIZES.LARGE,
    });

    return (
        <div className={layoutClassNames}>{children}</div>
    );
}
